<!-- <app-mytel-header></app-mytel-header> -->
<div>
  <nz-layout [class.ant-layout-has-sider]="!isHorizontal">
    <ng-container [ngTemplateOutlet]="isHorizontal ? menuHorTpl : menuVerTpl"></ng-container>
   <nz-content>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
   </nz-content>
  </nz-layout>
</div>
<ng-template #menuHorTpl>
  <nz-header class="shadow-sm bg-color-dark">
    <div class="d-flex justify-content-between vss-ui-menu-header">
      <div class="logo" style="text-align: center; cursor: pointer;" (click)="redirectUserHome()">
        <img [class]="isCollapsed ? 'logo-change' : 'logo-default'" [src]="isCollapsed ? './assets/images/the-cong-viettel.png' : './assets/images/the-cong-viettel.png'" alt="">
      </div>
      <div class="d-flex vss-ui-nav-menu">
        <ng-container *ngTemplateOutlet="extendStartTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="menuTpl"></ng-container>
        <ng-container *ngTemplateOutlet="extendEndTpl"></ng-container>
       <!-- <a *ngIf="currentLang === 'vi'" style="display: flex;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language" [nzPlacement]="'bottomRight'">
          <img style="width: 1.625rem; height: 1.625rem; border-radius: 48px; border: solid 1px #fff; margin: auto;" src="./../../../assets/images/language-vietnamese.png" alt="">
        </a>
        <a *ngIf="currentLang === 'en'" style="margin-top: 4px;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language" [nzPlacement]="'bottomRight'">
            <img style="width: 1.625rem; height: 1.625rem; border-radius: 48px; border: solid 1px #fff;" src="./../../../assets/images/language-english.png" alt="">
        </a> -->
        <!-- <nz-dropdown-menu #language="nzDropdownMenu">
                <ul style="padding: 0.5rem !important;" nz-menu nzMode="horizontal" class="language" [nzInlineCollapsed]="true">
                    <li style="padding: 0.5rem 0.75rem !important;" nz-menu-item *ngFor="let item of listLang; trackBy: trackByFn" (click)="onSelectLange(item.id)" [nzSelected]="item.id == currentLang">
                        <img style="width: 1.75rem; height: 1.25rem; border-radius: 0.125rem; margin-right: 1rem;" [src]="item.icon" alt="">{{ item.value | translate}}
                    </li>
                </ul>
        </nz-dropdown-menu> -->
        <!-- <a style="display: flex;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="notify">
            <img style="width: 1.625rem; height: 1.625rem; margin: auto;" src="./../../../assets/images/thongbao-color-black.svg" alt="">
        </a>
        <nz-dropdown-menu #notify="nzDropdownMenu">
            <nz-card class="card-notify" [nzTitle]="'MENU.NOTIFY' | translate">
                <div *ngIf="lstNotify.length; else noData">

                </div>
                <ng-template #noData>
                    <nz-empty nzNotFoundImage="/assets/icons/empty.svg" [nzNotFoundContent]="contentTpl"></nz-empty>
                  </ng-template>
                  <ng-template #contentTpl>
                    <span>
                      {{'BASE.NO_DATA_2' | translate}}
                    </span>
                  </ng-template>
            </nz-card>
        </nz-dropdown-menu>
        <a style="display: flex;" (click)="openDrawerInfo()">
            <img class="user-info" [src]="'./assets/icons/Asset 8@2x.png'" alt="">
        </a>
        <nz-drawer *ngIf="visibleDrawerInfo"
            [nzBodyStyle]="{ overflow: 'auto' }"
            [nzMaskClosable]="false"
            [nzWidth]="436"
            [nzVisible]="visibleDrawerInfo"
            [nzTitle]="'MENU.USER_INFO' | translate"
            [nzCloseIcon]="'icons:icon-close-popup'"
            (nzOnClose)="closeDrawerInfo()"
            >
            <div *nzDrawerContent>
                <div class="user" style="text-align: center;">
                    <img class="avatar" [src]="'./assets/icons/Asset 8@2x.png'" alt="">
                    <div class="userName">{{ user?.userName }}</div>
                    <div class="email">{{ user?.email }}</div>
                </div>
                <div class="detail">
                    <div class="row">
                        <div class="col-md-5 title">
                            {{ 'MENU.DEPARTMENT' | translate }}
                        </div>
                        <div class="col-md-7 info">
                            {{ user?.departmentName }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5 title">
                            {{ 'MENU.POSITION' | translate }}
                        </div>
                        <div class="col-md-7 info">
                            {{ user?.positionName }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5 title">
                            {{ 'MENU.POSITION_OTHER' | translate }}
                        </div>
                        <div class="col-md-7 info">
                            {{ user?.positionOther ? user?.positionOther : '-' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5 title">
                            {{ 'MENU.GENDER' | translate }}
                        </div>
                        <div class="col-md-7 info">
                            {{ user?.gender }}
                        </div>
                    </div>
                </div>
                <div class="logout" style="text-align: center;">
                    <button nz-button nzType="default" class="colorBtn" type="button" (click)="logout()">
                        {{'HOME.LOGOUT' | translate}}</button>
                </div>
            </div>
        </nz-drawer> -->
      </div>
    </div>
  </nz-header>
</ng-template>
<ng-template #menuVerTpl>
  <nz-sider [nzWidth]="280" nzCollapsible
            [(nzCollapsed)]="isCollapsed" [nzTrigger]="null"
            class="shadow-sm bg-color-dark sidebar"
            style="background: #fff;"
            [class]="isCollapsed ? 'menu-sidebar-fix' : 'menu-sidebar'">
<!--            (mouseenter)="expandSidebar()"-->
<!--            (mouseleave)="collapseSidebar()">-->
    <div class="h-100 d-flex  justify-content-between flex-column vss-ui-menu-slider">
      <div>
        <div [class]="isCollapsed ? 'logo logo-img-change' : 'logo logo-img-default' " [style]="isCollapsed ? 'text-align: center; cursor: pointer;' : 'text-align: left; cursor: pointer; display: flex; justify-content: center '" (click)="redirectUserHome()">
          <img [class]="isCollapsed ? 'logo-change' : 'logo-default'" [src]="isCollapsed ? './assets/images/the-cong-viettel.png' : './assets/images/the-cong-viettel.png'" alt="">
<!--          <span *ngIf="!isCollapsed" class="title-codev" >VTSPORT</span>-->
        </div>
        <hr class="w-75 m-auto mb-1" *ngIf="isCollapsed">
        <ng-container *ngTemplateOutlet="extendStartTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="menuTpl" [ngTemplateOutletContext]="{collapsed: isCollapsed}"></ng-container>
      </div>
      <div class="cuz-collaps d-none">
        <ng-container *ngTemplateOutlet="extendEndTpl"></ng-container>
        <!-- Thông báo -->
        <!-- <div [class]="isCollapsed ? 'notification-change' : 'notification-default'" nz-dropdown nzTrigger="click" [nzDropdownMenu]="notify" [nzPlacement]="'topRight'" [nz-tooltip]="isCollapsed ? ('MENU.NOTIFY' | translate) : ''" nzTooltipPlacement="right">
          <img src="./assets/icons/icon-notification.svg" alt=""> <span *ngIf="!isCollapsed" class="title-notification">{{ 'MENU.NOTIFY' | translate }}</span>
        </div>
        <nz-dropdown-menu #notify="nzDropdownMenu">
          <nz-card class="card-notify" [nzTitle]="'MENU.NOTIFY' | translate">
            <div *ngIf="lstNotify.length; else noData">

                </div>
                <ng-template #noData>
                  <nz-empty nzNotFoundImage="/assets/icons/empty.svg" [nzNotFoundContent]="contentTpl"></nz-empty>
                </ng-template>
                <ng-template #contentTpl>
                  <span>
                    {{'BASE.NO_DATA_2' | translate}}
                  </span>
                </ng-template>
              </nz-card>
            </nz-dropdown-menu> -->
        <!-- Ngôn ngữ -->
        <!-- <a *ngIf="currentLang === 'vi'" style="display: flex;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language" [nzPlacement]="'topRight'">
          <img style="width: 1.625rem; height: 1.625rem; border-radius: 48px; border: solid 1px #fff; margin: auto;" src="./../../../assets/images/language-vietnamese.png" alt="">
        </a>
        <a *ngIf="currentLang === 'en'" style="margin-top: 4px;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language" [nzPlacement]="'topRight'">
            <img style="width: 1.625rem; height: 1.625rem; border-radius: 48px; border: solid 1px #fff;" src="./../../../assets/images/language-english.png" alt="">
        </a> -->
        <!-- <div [class]="isCollapsed ? 'language-change' : 'language-default'" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language" [nzPlacement]="'topRight'" [nz-tooltip]="isCollapsed ? ('MENU.LANGUAGE.LANGUAGE' | translate) : ''" nzTooltipPlacement="right">
        </div>
        <nz-dropdown-menu #language="nzDropdownMenu">
          <ul style="padding: 0.5rem !important;" nz-menu nzMode="horizontal" class="language" [nzInlineCollapsed]="true">
              <li style="padding: 0.5rem 0.75rem !important;" nz-menu-item *ngFor="let item of listLang; trackBy: trackByFn" (click)="onSelectLange(item.id)" [nzSelected]="item.id == currentLang">
                  <img style="width: 1.75rem; height: 1.25rem; border-radius: 0.125rem; margin-right: 1rem;" [src]="item.icon" alt="">{{ item.value | translate}}
              </li>
          </ul>
        </nz-dropdown-menu> -->
        <hr class="hr-menu">
      </div>
    </div>
  </nz-sider>
<!--  <span *ngIf="isCollapsed" class="expand" (click)="changeExpand()">-->
<!--    <img src="/assets/icons/icon-collapse.svg">-->
<!--  </span>-->
<!--  <span *ngIf="!isCollapsed" class="collapse" (click)="changeExpand()">-->
<!--    <img src="/assets/icons/icon-collapse.svg">-->
<!--  </span>-->
</ng-template>
<ng-template #menuTpl let-collapsed="collapsed">
  <div class="menu-nav-root" [class]="isCollapsed ? 'wrapper-collapsed cs-menu' : 'wrapper cs-menu'">
<!--    <ul nz-menu nzTheme="light" class="h-100" [nzMode]="isHorizontal? 'horizontal':'inline'"-->
    <ul nz-menu nzTheme="light" class="h-100 parent-category" [nzMode]="'inline'"
        [nzInlineCollapsed]="collapsed">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: listMenus }"></ng-container>
      <ng-template #menuTpl let-menus>
        <ng-container *ngFor="let menu of menus">
          <!-- <ng-container *ruleAuthorized="menu.roles || []"> bỏ tạm sau có quyền thì thêm -->
          <ng-container>
            <li *ngIf="!menu.children.length" nz-menu-item [nzDisabled]="menu.disabled" (click)="clickItem(menu)"
                [nz-tooltip]="(collapsed && menu.level === 0 ? menu.titleKey || '' : '') | translate" nzTooltipPlacement="right"
                [nzPaddingLeft]="!collapsed && !isHorizontal ? (menu.level - 1) * 24 : 0"
                [nzSelected]="currentPage?.id === menu.id ">
              <ng-container [ngTemplateOutlet]="titleMenu"></ng-container>
            </li>
            <li *ngIf="menu.children.length" nz-submenu
                [class.active-sub-menu]="currentPage?.parent === menu.id"
                [nzTitle]="titleMenu"
                [nzPaddingLeft]="!collapsed && !isHorizontal ? (menu.level - 1) * 24 : 0"
                [nzDisabled]="menu.disabled">
              <ul>
                <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"></ng-container>
              </ul>
            </li>
            <ng-template #titleMenu>
              <i class="icon-menu" *ngIf="menu.icon && !isHorizontal && !currentPage.url.includes(menu.url)" nz-icon [nzType]="menu.icon"  aria-hidden="true"
              ></i>
              <i class="icon-menu" *ngIf="menu.iconActive && !isHorizontal && currentPage.url.includes(menu.url)" nz-icon [nzType]="menu.icon"  aria-hidden="true"></i>
              <span [class]="isCollapsed ? (menu.level === 0 ? 'title-menu-change' : 'title-menu-default') : 'title-menu-default'">{{ menu.titleKey | translate }}</span>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-template>
    </ul>
  </div>
</ng-template>
